/**
 * In-memory flag to bridge the gap between onboarding completion
 * (DB write) and the profile context refreshing.
 * This prevents the tabs layout from bouncing back to onboarding.
 */
let _justCompletedOnboarding = false;

export function markOnboardingJustCompleted() {
  _justCompletedOnboarding = true;
}

export function didJustCompleteOnboarding(): boolean {
  return _justCompletedOnboarding;
}

export function clearOnboardingJustCompleted() {
  _justCompletedOnboarding = false;
}
